import { call, put } from 'redux-saga/effects';
import { resendActivationFailure, resendActivationSuccess } from '../actions';
import { resend } from '../api';
import { ResendActivationRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { MessageType } from 'store/api/enums';
import { logoutRequest } from 'store/auth/actions';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* resendActivationSaga(action: ResendActivationRequestAction) {
  try {
    let err: ApiError | null;

    const { email, invited } = action.payload;
    const response: ApiResponse = yield call(resend, email);
    err = checkResponse(response?.responseMessage);
    if (err) throw err;
    if (invited) {
      const message: MessageData = {
        title: i18n.t('common.success'),
        description: i18n.t('notifications.activation-email-sent'),
        type: MessageStates.SUCCESS,
      };
      yield put(turnMessageOn(message));
    } else if (response.responseMessage.messageType === MessageType.INFO) {
      const message: MessageData = {
        title: i18n.t('notifications.server-message'),
        description: response.responseMessage.message,
        type: MessageStates.INFO,
      };
      yield put(turnMessageOn(message));
    } else yield put(push(routes.signUp.signupSuccess));
    yield put(resendActivationSuccess());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(resendActivationFailure());
  }
}
